<template>
  <div id="app" class="applica">
    <router-view :key="this.$route.path"></router-view>
  </div>
</template>

<script>
  export default {
    name: "App",
  };
</script>

<style lang="scss">
  @import "@/assets/scss/base.scss";
  #app{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue